export function isWebSocketConnected(ws: WebSocket | null): boolean {
	return ws !== null && ws.readyState === WebSocket.OPEN;
}
